import React from 'react';
import styles from "./FAQs.module.scss";
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';
import DynamicTableFilters from '../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { FAQsTableData, refundTransactionsTableData } from '../../../../views/AdminPortal/dummyData';

const FAQsComp = ({ setDetails }) => {
    const navigate = useNavigate();



    const ampleOptions = [
        { label: "View detail", action: () => setDetails() },
        { label: "Edit", action: () => console.log("Activate Product") },
        { label: "Delete", action: () => console.log("Notify Seller") },
        { label: "Change Status", action: () => console.log("Notify Seller") },
    ];

    const columns = [
        {
            name: "SL#",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Category",
            selector: (row) => row.category,
            center: "true",
            width: "150px",
        },
        {
            name: "Sub-Category",
            selector: (row) => row.subCategory,
            center: "true",
            width: "150px",
        },
        {
            name: "Question",
            selector: (row) => row.question,
            center: "true",
        },
        {
            name: "Answer",
            selector: (row) => row.answer,
            center: "true",
        },

        {
            name: "Ranking",
            selector: (row) => row.ranking,
            center: "true",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            center: "true",
        },
        {
            name: "Action",
            // cell: (row) => <ActionButton options={ampleOptions} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters  componentName={"Refund Transactions"} apply={false} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={FAQsTableData}
                    columns={columns}
                    type="yellow"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default FAQsComp;